/**
 * 异步处理mutations， 可以在这里使用commit
 */
import * as types from './mutation-types.js';
import { getHealthArchivesByLoginUser } from '@/api/test-center'
import { decryptBy, encryptBy } from '@/assets/js/encryption';
export default {
  dialog({ commit }, { showDialog }) {
    commit(types.SHOW_DIALOG, showDialog);
  },
  userInfo({ commit }, { userInfo }) {
    commit(types.USER_INFO, userInfo);
  },
  deviceInfo({ commit }, { deviceInfo }) {
    commit(types.DEVICE_INFO, deviceInfo);
  },
  loading({ commit }, { loading }) {
    commit(types.LOADING, loading);
  },
  children({ commit }) {
    return new Promise((reslove, reject) => {
      getHealthArchivesByLoginUser().then(res => {
        if (res.data) {
          commit(types.CHILDREN, res.data)
          commit(types.CHILDID,  res.data[0].id)
          localStorage.setItem('children', encryptBy(JSON.stringify(res.data)))
        }
        reslove(res)
      })
    })
  },
};
